
import PenRemove from "../../../assets/duotone/PenRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PenRemoveIcon({ className, dataTestid = "PenRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PenRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
